import React, { useState, useEffect, useMemo } from "react";
// import moment from 'moment';
import Datetime from "react-datetime";
import axios from "axios";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import "../../../assets/css/custom.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Alert } from "reactstrap";
import Autocomplete from "react-google-autocomplete";
import ShowBoitierMap from "./showBoitierMap.js";
import BoitierLastAlert from "./boitierLastAlert.js";
import ShowBoitierAssign from "./showBoitierAssign.js";
import ShowBoitierComment from "./showBoitierComment.js";
import ShowBoitierImage from "./showBoitierImage.js";
import AlertMailSetup from "./AlertMailSetup";
import { API_URL, getApiConfig, getUserRoleId } from "../Config/apiConfig.js";

export default function ShowBoitierHeader() {
  const userRoleId = getUserRoleId();
  const nav = useNavigate();
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [formVisible, setFormVisible] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleToggleForm = () => {
    setFormVisible(!formVisible);
    setGoogleAddressSelected(false); // Réinitialise à chaque ouverture du formulaire
  };

  const [dropdownOpenForVersion, setDropdownOpenForVersion] = useState(false);
  const toggleDropVersion = () =>
    setDropdownOpenForVersion((prevState) => !prevState);
  const [dropdownOpenForLeasing, setDropdownOpenForLeasing] = useState(false);
  const toggleDropLeasing = () =>
    setDropdownOpenForLeasing((prevState) => !prevState);
  const [dropdownOpenForGuarantee, setDropdownOpenForGuarantee] =
    useState(false);
  const toggleDropGuarantee = () =>
    setDropdownOpenForGuarantee((prevState) => !prevState);
  const [dropdownOpenForBoost, setDropdownOpenForBoost] = useState(false);
  const toggleDropBoost = () =>
    setDropdownOpenForBoost((prevState) => !prevState);
  const [dropdownOpenForState, setDropdownOpenForState] = useState(false);
  const toggleDropState = () =>
    setDropdownOpenForState((prevState) => !prevState);
  const [dropdownOpenForGenA, setDropdownOpenForGenA] = useState(false);
  const toggleDropGenA = () =>
    setDropdownOpenForGenA((prevState) => !prevState);
  const [dropdownOpenForGenB, setDropdownOpenForGenB] = useState(false);
  const toggleDropGenB = () =>
    setDropdownOpenForGenB((prevState) => !prevState);
  const [dropdownOpenForCoTime, setDropdownOpenForCoTime] = useState(false);
  const toggleDropCoTime = () =>
    setDropdownOpenForCoTime((prevState) => !prevState);
  const [dropdownOpenForLanguage, setDropdownOpenForLanguage] = useState(false);
  const toggleDropLanguage = () =>
    setDropdownOpenForLanguage((prevState) => !prevState);
  const [dropdownOpenForVisibleVersion, setDropdownOpenForVisibleVersion] = useState(false);
  const toggleDropVisibleVersion = () =>
    setDropdownOpenForVisibleVersion((prevState) => !prevState);

  const params = useParams();

  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");

  const [boitier_id, setBoitier_id] = useState("");
  const [comment, setComment] = useState("");
  const [markerLat, setMarkerLat] = useState("");
  const [markerLng, setMarkerLng] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postcode, setPostcode] = useState("");
  const [country, setCountry] = useState("");
  const [versionSoftware, setVersionSoftware] = useState("");
  const [modeBoost, setModeBoost] = useState("");
  const [connectionTimeLimit, setConnectionTimeLimit] = useState("");
  const [dateActivation, setDateActivation] = useState("");
  const [formattedDate, setFormattedDate] = useState(null);
  const [state, setState] = useState("");
  const [generatorStateA, setGeneratorStateA] = useState("");
  const [generatorStateB, setGeneratorStateB] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [user_id, setUser_id] = useState("");
  const [leasing, setLeasing] = useState("");
  const [dateLeasing, setDateLeasing] = useState("");
  const [guarantee, setGuarantee] = useState("");
  const [dateGuarantee, setDateGuarantee] = useState("");
  const [previousLSValue, setPreviousLSValue] = useState("");
  const [previousGRValue, setPreviousGRValue] = useState("");
  const [mail_alerte, setMail_alerte] = useState("");
  const [language, setLanguage] = useState("francais");

  const [MB, setMB] = useState("");
  const [STATUS, setSTATUS] = useState("");
  const [GNA, setGNA] = useState("");
  const [GNB, setGNB] = useState("");
  const [CTL, setCTL] = useState("");
  const [LS, setLS] = useState("");
  const [GR, setGR] = useState("");
  const [boitierVersion, setBoitierVersion] = useState("");
  const [versionVisible, setVersionVisible] = useState("");
  const [displayVersionVisible, setDisplayVersionVisible] = useState("");

  const [isVersion4, setIsVersion4] = useState(false);
  const [displayVersionSoftware, setDisplayVersionSoftware] = useState("");

  const connectionTimeLimitMap = useMemo(
    () => ({
      "sans délais": 1,
      "10 jours": 2,
      "30 jours": 3,
      "90 jours": 4,
      "180 jours": 5,
    }),
    []
  );

  const leasingMap = useMemo(
    () => ({
      "12 mois": 1,
      "24 mois": 2,
      "36 mois": 3,
      "48 mois": 4,
      "pas de contrat": 5,
    }),
    []
  );

  const guaranteeMap = useMemo(
    () => ({
      "12 mois": 1,
      "24 mois": 2,
      "36 mois": 3,
      "48 mois": 4,
    }),
    []
  );

  useEffect(() => {
    setMB(modeBoost === "actif" ? 1 : 0);
    setSTATUS(state === "actif" ? 1 : 0);
    setGNA(generatorStateA === "actif" ? 1 : 0);
    setGNB(generatorStateB === "actif" ? 1 : 0);
    setCTL(
      connectionTimeLimitMap[connectionTimeLimit] ||
        connectionTimeLimitMap.default
    );
    setLS(leasingMap[leasing] || leasingMap.default);
    setGR(guaranteeMap[guarantee] || guaranteeMap.default);
    // eslint-disable-next-line
  }, [
    modeBoost,
    state,
    generatorStateA,
    generatorStateB,
    connectionTimeLimit,
    leasing,
    guarantee,
    language,
  ]);

  useEffect(() => {
    if (dateActivation && !isNaN(new Date(dateActivation))) {
      setFormattedDate(new Date(dateActivation).toLocaleDateString("en-GB"));
    }
  }, [dateActivation]);

  const fullAddress = `${address}, ${city}, ${postcode}, ${country}`;

  const [googleAddressSelected, setGoogleAddressSelected] = useState(false);
  const [initialAddress, setInitialAddress] = useState("");

  const handleSubmitFor = async (e) => {
    e.preventDefault();
    // Si l'adresse n'a pas changé, ne pas exiger la sélection Google
    if (address !== initialAddress && !googleAddressSelected) {
      setAlertContent(
        <Alert color="danger">
          Merci de choisir une adresse dans la liste de suggestions Google.
        </Alert>
      );
      setAlert(true);
      setTimeout(() => setAlert(false), 3000);
      return;
    }

    // Géocode toujours la valeur brute de l'input d'adresse
    await geocodeAddress(address);

    // Formatage du versionSoftware selon la version du boîtier
    const formattedVersionSoftware = isVersion4
      ? versionSoftware
      : versionSoftware; // Pour V3, on envoie juste le chiffre qui est déjà formaté

    let payload = {
      dateActivation: dateActivation,
      comment: comment,
      markerLat: markerLat,
      markerLng: markerLng,
      address: address,
      city: city,
      postcode: postcode,
      country: country,
      modeBoost: MB,
      state: STATUS,
      versionSoftware: formattedVersionSoftware,
      versionVisible: versionVisible, // Ajouter la version visible au payload
      generatorStateA: GNA,
      generatorStateB: GNB,
      ConnectionTimeLimit: CTL,
      mail_alerte: mail_alerte,
      language: language, // Utiliser directement la chaîne au lieu du code
    };

    if (LS !== previousLSValue) {
      payload.leasing = LS;
    }
    if (GR !== previousGRValue) {
      payload.guarantee = GR;
    }

    axios
      .post(API_URL + `updateBoitierInfo/${params.id}`, payload, getApiConfig())
      .then(function (response) {
        // console.log("response", response);
        if (response.data === "success") {
          setAlertContent(
            <Alert color="success">Les données ont bien été enregistrées !</Alert>
          );
          setAlert(true);
          const timeId = setTimeout(() => {
            setAlert(false);
          }, 3000);
        } else {
          setAlertContent(
            <Alert color="danger">
              Une erreur est survenue, veuillez réessayer
            </Alert>
          );
          setAlert(true);
          const timeId = setTimeout(() => {
            setAlert(false);
          }, 3000);
        }
      });
    setFormSubmitted(false);
    setFormVisible(false);
  };

  const location = useLocation();
  const isOld = location.state?.isOld;
  const idBoitier = location.state?.id;
  // console.log("isOld", isOld);

  //AXIOS GET REQUEST

  useEffect(() => {
    let showBoitierRequest = axios.get(
      API_URL + `showBoitier/${params.id}`,
      getApiConfig()
    );

    let showContractRequest = axios.get(
      API_URL + `showContract/${params.id}`,
      getApiConfig()
    );

    axios
      .all([showBoitierRequest, showContractRequest])
      .then(
        axios.spread(function (res1, res2) {
          setLeasing(res2.data?.leasing);
          setDateLeasing(res2.data?.dateLeasing);
          setGuarantee(res2.data?.guarantee);
          setPreviousLSValue(res2.data?.dateLeasing);
          setPreviousGRValue(res2.data?.guarantee);
          setDateGuarantee(res2.data?.dateGuarantee);
          setBoitier_id(res1.data?.id);
          setComment(res1.data?.comment);
          setAddress(res1.data?.address);
          setCity(res1.data?.city);
          setPostcode(res1.data?.postcode);

          setCountry(res1.data?.country);

          setVersionSoftware(res1.data?.versionSoftware);
          setModeBoost(res1.data?.modeBoost);
          // console.log(res1.data?.modeBoost, "modeBoost");
          setConnectionTimeLimit(res1.data?.ConnectionTimeLimit);
          setDateActivation(res1.data?.dateActivation);
          setState(res1.data?.state);
          setGeneratorStateA(res1.data?.generatorStateA);
          setGeneratorStateB(res1.data?.generatorStateB);
          setCustomerName(res1.data?.user.company);
          setUser_id(res1.data?.user_id);
          setMarkerLat(res1.data?.markerLat);
          setMarkerLng(res1.data?.markerLng);
          setMail_alerte(res1.data?.mail_alerte);
          setInitialAddress(res1.data?.address || "");
          setBoitierVersion(res1.data?.boitier_version);
          setLanguage(res1.data?.language || "francais");

          // Déterminer si c'est un boîtier version 4 en se basant sur le champ boitier_version
          const isV4 = res1.data?.boitier_version === 'v4';
          setIsVersion4(isV4);
          
          // Simplifier la gestion de versionSoftware
          setVersionSoftware(res1.data?.versionSoftware || "1");
          setDisplayVersionSoftware(res1.data?.versionSoftware || "1");
          
          // Simplifier la gestion de versionVisible
          setVersionVisible(res1.data?.versionVisible || res1.data?.versionSoftware || "1");
          setDisplayVersionVisible(res1.data?.versionVisible || res1.data?.versionSoftware || "1");
          
          console.log("Version du boitier:", res1.data?.boitier_version, "isV4:", isV4, "versionSoftware:", versionSoftware);
          
          // Autres assignations existantes...
          // ...
        })
      )
      .catch((err) => {});
  }, [params.id]);

  const geocodeAddress = async (addressValue) => {
    try {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: addressValue }, (results, status) => {
        if (status === "OK" && results[0]) {
          const Ulocation = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          };
          setMarkerLat(Ulocation.lat);
          setMarkerLng(Ulocation.lng);
          // Met à jour les sous-champs si trouvés dans le résultat du géocodeur
          const comps = results[0]?.address_components;
          const cityComp = comps.find(c => c.types.includes("locality"));
          if (cityComp) setCity(cityComp.long_name);
          const postcodeComp = comps.find(c => c.types.includes("postal_code"));
          if (postcodeComp) setPostcode(postcodeComp.long_name);
          const countryComp = comps.find(c => c.types.includes("country"));
          if (countryComp) setCountry(countryComp.long_name);
        } else {
          console.error("Geocoding error:", status);
        }
      });
    } catch (error) {
      console.error("Geocoding error:", error);
    }
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
    setGoogleAddressSelected(false); // Toujours remettre à false dès qu'on tape
  };

  const handlePlaceSelected = (place) => {
    setGoogleAddressSelected(true);
    if (!place?.address_components) return;
    const route = place?.address_components.find(
      c => c.types[0] === "route"
    )?.long_name || "";
    const streetNumber = place?.address_components.find(
      c => c.types[0] === "street_number"
    )?.long_name || "";
    const full = streetNumber ? `${route} ${streetNumber}`.trim() : route;
    setAddress(full);
    // Met à jour les autres champs si trouvés
    const postalCodeComponent = place?.address_components.find(
      c => c.types[0] === "postal_code"
    );
    if (postalCodeComponent) setPostcode(postalCodeComponent.long_name);
    const cityComponent = place?.address_components.find(
      c => c.types[0] === "locality"
    );
    if (cityComponent) setCity(cityComponent.long_name);
    const countryComponent = place?.address_components.find(
      c => c.types[0] === "country"
    );
    if (countryComponent) setCountry(countryComponent.long_name);
  };

  // Ajouter ces états pour gérer la modale d'alerte
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const toggleAlertModal = () => setAlertModalOpen(!alertModalOpen);

  // console.log("userRoleId dans header:", userRoleId);

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "10%",
          right: "10%",
          left: "20%",
          zIndex: "999",
        }}
      >
        {alert ? <div>{alertContent}</div> : <></>}
      </div>

      <Col className="noPad" lg="12">
        <Row className="CenterAll">
          <div className="containertitle">
            <h2 className="titlePage">INFORMATIONS GENERALES</h2>
          </div>
        </Row>
        <Card>
          <CardBody>
            <Row className="CenterAll">
              <Col lg="12" className="mt-4 noPad">
                <Row>
                  <Col lg="5" md="6" className="noPad ">
                    {!formVisible || formSubmitted ? (
                      <div>
                        <Card className="cardContainer">
                          <CardBody>
                            <div className="containerTextCard noMarg">
                              <h4 className="titleCard ">
                                BOITIER N° {boitier_id}
                              </h4>
                              <div
                                style={{
                                  borderTop: "0.5px solid #fff",
                                  marginBottom: "20px",
                                }}
                              ></div>
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">
                                    Date d'activation
                                  </div>
                                  <div className="textRow">{formattedDate}</div>
                                </Row>
                              </Card>
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">Version</div>
                                  <div className="textRow">
                                    {boitierVersion}
                                  </div>
                                </Row>
                              </Card>
                                {/* Modele visible : affichage pour tout le monde sauf admin */}
                              {userRoleId !== "1" && (
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">
                                    Modèle 
                                  </div>
                                  <div className="textRow">
                                    {displayVersionVisible}
                                  </div>
                                </Row>
                              </Card> 
                                )}
                              {userRoleId === "1" && (
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">Modèle </div>
                                    <div className="textRow">
                                      {displayVersionSoftware}
                                    </div>
                                  </Row>
                                </Card>
                              )}
                              {/* Modele visible : Affichage pour l'admin */}
                              {userRoleId === "1"  && (
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">
                                    Modèle visible
                                  </div>
                                  <div className="textRow">
                                    {displayVersionVisible}
                                  </div>
                                </Row>
                              </Card> 
                                )}

                              {userRoleId === "1" && (
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">Mode boost</div>
                                    <div className="textRow">{modeBoost}</div>
                                  </Row>
                                </Card>
                              )}
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">
                                    Etat du boitier
                                  </div>
                                  <div className="textRow">{state}</div>
                                </Row>
                              </Card>
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">
                                    Etat générateur A
                                  </div>
                                  <div className="textRow">
                                    {generatorStateA}
                                  </div>
                                </Row>
                              </Card>
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">
                                    Etat générateur B
                                  </div>
                                  <div className="textRow">
                                    {generatorStateB}
                                  </div>
                                </Row>
                              </Card>
                              {userRoleId != "5" && (
                              <Card className="rowContainer">
                                        <Row>
                                        <div className="titleRow" >
                                            Délai sans connexion
                                        </div>
                                        <div className="textRow" >{connectionTimeLimit}</div> 
                                        </Row>
                                </Card> )}
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">
                                    Emplacement du boitier
                                  </div>
                                  <div className="textRow">
                                  {address ? `${address}, ` : ""}{postcode} {city} {country}
                                  </div>
                                </Row>
                              </Card>
                              {/* Remplacement du champ emails par un bouton + modal */}
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">Langue</div>
                                  <div className="textRow">
                                    {language}
                                  </div>
                                </Row>
                              </Card>
                              <Card className="rowContainer">
                                <Row>
                                  <div className="titleRow">Capteurs & Alertes</div>
                                  <div className="textRow">
                                    <Button color="primary" onClick={toggleAlertModal}>
                                      Éditer / Gérer
                                    </Button>
                                  </div>
                                </Row>
                              </Card>
                              <Modal isOpen={alertModalOpen} toggle={toggleAlertModal} size="xl" className="modal-alert-setup">
                                <ModalHeader toggle={toggleAlertModal}>Édition Alerte</ModalHeader>
                                <ModalBody>
                                  <AlertMailSetup boitierId={params.id} />
                                </ModalBody>
                              </Modal>
                            </div>
                            {(userRoleId == 1 || userRoleId == 4) && (
                              <div className="text-center">
                                <Button
                                  color="primary"
                                  onClick={handleToggleForm}
                                >
                                  Editer
                                </Button>
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </div>
                    ) : (
                      <div>
                        <form onSubmit={handleSubmitFor}>
                          <Card className="cardContainer">
                            <CardBody>
                              <div className="containerTextCard">
                                <h4 className="titleCard">
                                  BOITIER N° {boitier_id}
                                </h4>
                                <div
                                  style={{
                                    borderTop: "0.5px solid #fff",
                                    marginBottom: "20px",
                                  }}
                                ></div>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">Date d'activation</div>
                                    <div className="textRow">
                                      {/* <div className="btn btn-light" onClick={() => setShowDatePicker(true)}>
                                                    {moment(dateActivation).format('DD/MM/YYYY')}
                                                </div> */}

                                      {/* {showDatePicker && ( */}
                                      {/* // <div className="date-picker-overlay"> */}
                                      <Datetime
                                        value={formattedDate}
                                        onChange={(value) => {
                                          setDateActivation(
                                            value.format("YYYY-MM-DD")
                                          );
                                          setShowDatePicker(false);
                                        }}
                                        // inputProps={{ className: 'heighTextArea pl-3' }}
                                        className="dropdown-boitier-custom"
                                        dateFormat="DD/MM/YYYY"
                                        timeFormat={false}
                                        closeOnSelect={true}
                                        onBlur={() => setShowDatePicker(false)}
                                      />
                                      {/* // </div> */}
                                      {/* )} */}
                                    </div>
                                  </Row>
                                </Card>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">Version</div>
                                    <div className="textRow">
                                      {boitierVersion}
                                    </div>
                                  </Row>
                                </Card>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">Modèle</div>
                                    <div className="textRow">
                                      <Dropdown
                                        isOpen={dropdownOpenForVersion}
                                        toggle={toggleDropVersion}
                                      >
                                        <DropdownToggle className="dropdown-boitier-custom">
                                          {displayVersionSoftware}
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-custom">
                                          {isVersion4 ? (
                                            // Options simplifiées pour boîtiers V4
                                            <>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"1"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                3.1
                                              </DropdownItem>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"2"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                3.2
                                              </DropdownItem>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"4"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                3.4
                                              </DropdownItem>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"5"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                3.5
                                              </DropdownItem>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"6"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                3.6
                                              </DropdownItem>
                                            </>
                                          ) : (
                                            // Options simplifiées pour boîtiers V3
                                            <>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"1"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                1
                                              </DropdownItem>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"2"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                2
                                              </DropdownItem>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"3"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                3
                                              </DropdownItem>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"4"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                4
                                              </DropdownItem>
                                              <DropdownItem
                                                style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                className="text-center"
                                                value={"5"}
                                                onClick={(e) => {
                                                  setVersionSoftware(e.target.value);
                                                  setDisplayVersionSoftware(e.target.value);
                                                }}
                                              >
                                                5
                                              </DropdownItem>
                                            </>
                                          )}
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  </Row>
                                </Card>
                                {userRoleId === "1" && (
                                  <Card className="rowContainer">
                                    <Row>
                                      <div className="titleRow">Modèle Visible</div>
                                      <div className="textRow">
                                        <Dropdown
                                          isOpen={dropdownOpenForVisibleVersion}
                                          toggle={toggleDropVisibleVersion}
                                        >
                                          <DropdownToggle className="dropdown-boitier-custom">
                                            3.{displayVersionVisible}
                                          </DropdownToggle>
                                          <DropdownMenu className="dropdown-menu-custom">
                                            {isVersion4 ? (
                                              // Options simplifiées pour boîtiers V4
                                              <>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"1"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  1
                                                </DropdownItem>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"2"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  2
                                                </DropdownItem>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"4"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  4
                                                </DropdownItem>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"5"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  5
                                                </DropdownItem>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"6"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  6
                                                </DropdownItem>
                                              </>
                                            ) : (
                                              // Options simplifiées pour boîtiers V3
                                              <>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"1"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  3.1
                                                </DropdownItem>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"2"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  3.2
                                                </DropdownItem>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"3"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  3.3
                                                </DropdownItem>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"4"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  3.4
                                                </DropdownItem>
                                                <DropdownItem
                                                  style={{ backgroundColor: "#9bc4de", color: "white" }}
                                                  className="text-center"
                                                  value={"5"}
                                                  onClick={(e) => {
                                                    setVersionVisible(e.target.value);
                                                    setDisplayVersionVisible(e.target.value);
                                                  }}
                                                >
                                                  3.5
                                                </DropdownItem>
                                              </>
                                            )}
                                          </DropdownMenu>
                                        </Dropdown>
                                      </div>
                                    </Row>
                                  </Card>
                                )}
                                {userRoleId === "1" && (
                                  <Card className="rowContainer">
                                    <Row>
                                      <div className="titleRow">Mode boost</div>
                                      <div className="textRow">
                                        <Dropdown isOpen={dropdownOpenForBoost} toggle={toggleDropBoost}>
                                          <DropdownToggle className="dropdown-boitier-custom">
                                            {modeBoost}
                                          </DropdownToggle>
                                          <DropdownMenu className="dropdown-menu-custom">
                                            <DropdownItem
                                              style={{ backgroundColor: "#9bc4de", color: "white" }}
                                              className="text-center"
                                              value={"actif"}
                                              onClick={(e) => setModeBoost(e.target.value)}
                                            >
                                              actif
                                            </DropdownItem>
                                            <DropdownItem
                                              style={{ backgroundColor: "#9bc4de", color: "white" }}
                                              className="text-center"
                                              value={"inactif"}
                                              onClick={(e) => setModeBoost(e.target.value)}
                                            >
                                              inactif
                                            </DropdownItem>
                                          </DropdownMenu>
                                        </Dropdown>
                                      </div>
                                    </Row>
                                  </Card>
                                )}
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">
                                      Etat du boitier
                                    </div>
                                    <div className="textRow">
                                      <Dropdown isOpen={dropdownOpenForState} toggle={toggleDropState}>
                                        <DropdownToggle className="dropdown-boitier-custom">
                                          {state}
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-custom">
                                          <DropdownItem
                                            style={{ backgroundColor: "#9bc4de", color: "white" }}
                                            className="text-center"
                                            value={"actif"}
                                            onClick={(e) => setState(e.target.value)}
                                          >
                                            actif
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{ backgroundColor: "#9bc4de", color: "white" }}
                                            className="text-center"
                                            value={"inactif"}
                                            onClick={(e) => setState(e.target.value)}
                                          >
                                            inactif
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  </Row>
                                </Card>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">
                                      Etat générateur A
                                    </div>
                                    <div className="textRow">
                                      <Dropdown isOpen={dropdownOpenForGenA} toggle={toggleDropGenA}>
                                        <DropdownToggle className="dropdown-boitier-custom">
                                          {generatorStateA}
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-custom">
                                          <DropdownItem
                                            style={{ backgroundColor: "#9bc4de", color: "white" }}
                                            className="text-center"
                                            value={"actif"}
                                            onClick={(e) => setGeneratorStateA(e.target.value)}
                                          >
                                            actif
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{ backgroundColor: "#9bc4de", color: "white" }}
                                            className="text-center"
                                            value={"inactif"}
                                            onClick={(e) => setGeneratorStateA(e.target.value)}
                                          >
                                            inactif
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  </Row>
                                </Card>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">
                                      Etat générateur B
                                    </div>
                                    <div className="textRow">
                                      <Dropdown isOpen={dropdownOpenForGenB} toggle={toggleDropGenB}>
                                        <DropdownToggle className="dropdown-boitier-custom">
                                          {generatorStateB}
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-custom">
                                          <DropdownItem
                                            style={{ backgroundColor: "#9bc4de", color: "white" }}
                                            className="text-center"
                                            value={"actif"}
                                            onClick={(e) => setGeneratorStateB(e.target.value)}
                                          >
                                            actif
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{ backgroundColor: "#9bc4de", color: "white" }}
                                            className="text-center"
                                            value={"inactif"}
                                            onClick={(e) => setGeneratorStateB(e.target.value)}
                                          >
                                            inactif
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  </Row>
                                </Card>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">
                                      Délai sans connexion
                                    </div>
                                    <div className="textRow">
                                      <Dropdown
                                        isOpen={dropdownOpenForCoTime}
                                        toggle={toggleDropCoTime}
                                      >
                                        <DropdownToggle
                                          id="unbelievable-override-hover"
                                          className="dropdown-boitier-custom"
                                        >
                                          {connectionTimeLimit}
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-custom">
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"sans délais"}
                                            onClick={(e) =>
                                              setConnectionTimeLimit(
                                                e.target.value
                                              )
                                            }
                                          >
                                            sans délais
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"10 jours"}
                                            onClick={(e) =>
                                              setConnectionTimeLimit(
                                                e.target.value
                                              )
                                            }
                                          >
                                            10 jours
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"30 jours"}
                                            onClick={(e) =>
                                              setConnectionTimeLimit(
                                                e.target.value
                                              )
                                            }
                                          >
                                            30 jours
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"90 jours"}
                                            onClick={(e) =>
                                              setConnectionTimeLimit(
                                                e.target.value
                                              )
                                            }
                                          >
                                            90 jours
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"180 jours"}
                                            onClick={(e) =>
                                              setConnectionTimeLimit(
                                                e.target.value
                                              )
                                            }
                                          >
                                            180 jours
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  </Row>
                                </Card>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">
                                      Emplacement du boitier
                                    </div>
                                    <div className="textRow" style={{ position: 'relative' }}>
                                      <Autocomplete
                                        apiKey={
                                          "AIzaSyCQrm7XQRxGSy8e0OFpSAT21_GFaB-Elcc&libraries=places"
                                        }
                                        className="heighTextArea pl-3 form-control"
                                        id="custom-input-row"
                                        name="no-autocomplete"
                                        autoComplete="off"
                                        autoCorrect="off"
                                        spellCheck={false}
                                        value={address}
                                        onChange={handleAddressChange}
                                        onKeyDown={e => {
                                          if (e.key === 'Enter') {
                                            e.preventDefault();
                                            setAlertContent(
                                              <Alert color="danger">
                                                Merci d'appuyer sur le bouton d'enregistrement pour valider votre modification
                                              </Alert>
                                            );
                                            setAlert(true);
                                            setTimeout(() => setAlert(false), 3000);
                                          }
                                        }}
                                        onPlaceSelected={handlePlaceSelected}
                                        options={{
                                          types: ["address"],
                                          componentRestrictions: { country: ["fr", "it", "mc"] },
                                        }}
                                        placeholder="Choisissez ou commencez à taper une adresse, puis sélectionnez une suggestion Google"
                                      />
                                    </div>
                                  </Row>
                                </Card>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">Langue</div>
                                    <div className="textRow">
                                      <Dropdown
                                        isOpen={dropdownOpenForLanguage}
                                        toggle={toggleDropLanguage}
                                      >
                                        <DropdownToggle className="dropdown-boitier-custom">
                                          {language}
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-custom">
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"francais"}
                                            onClick={(e) => setLanguage(e.target.value)}
                                          >
                                            Français
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"italien"}
                                            onClick={(e) => setLanguage(e.target.value)}
                                          >
                                            Italien
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"anglais"}
                                            onClick={(e) => setLanguage(e.target.value)}
                                          >
                                            Anglais
                                          </DropdownItem>
                                          <DropdownItem
                                            style={{
                                              backgroundColor: "#9bc4de",
                                              color: "white",
                                            }}
                                            className="text-center"
                                            value={"espagnol"}
                                            onClick={(e) => setLanguage(e.target.value)}
                                          >
                                            Espagnol
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  </Row>
                                </Card>
                                <Card className="rowContainer">
                                  <Row>
                                    <div className="titleRow">Capteurs & Alertes</div>
                                    <div className="textRow">
                                      <Button color="primary" onClick={toggleAlertModal}>
                                        Éditer / Gérer
                                      </Button>
                                    </div>
                                  </Row>
                                </Card>
                                <Modal isOpen={alertModalOpen} toggle={toggleAlertModal} size="xl" className="modal-alert-setup">
                                  <ModalHeader toggle={toggleAlertModal}>
                                    Édition Alerte
                                  </ModalHeader>
                                  <ModalBody>
                                    <AlertMailSetup boitierId={params.id} />
                                  </ModalBody>
                                </Modal>
                              </div>
                              <div className="text-center">
                                <Button type="submit" color="primary">
                                  Enregistrer
                                </Button>
                              </div>
                            </CardBody>
                          </Card>
                        </form>
                      </div>
                    )}
                    <ShowBoitierAssign
                      user_id={user_id}
                      customer_Name={customerName}
                    />
                  </Col>

                  <Col lg="7" md="6">
                    <Card>
                      {/* googleMap */}
                      <ShowBoitierMap
                        markerLat={markerLat}
                        markerLng={markerLng}
                      />
                      <ShowBoitierComment
                        comment={comment}
                        setComment={setComment}
                        handleSubmitFor={handleSubmitFor}
                      />
                      <ShowBoitierImage />
                      <BoitierLastAlert />
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </>
  );
}
